import { useTheme } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CheckIcon from '@mui/icons-material/Check';
import DSBox from '../../../design-system/DSBox';
import DSButton from '../../../design-system/DSButton';
import DSPrimaryButton from '../../../design-system/DSPrimaryButton';
import DSCircularProgress from '../../../design-system/DSCircularProgress';
import { DSTypography } from '../../../design-system/Typography';

type AffiliateLinkReadyViewProps = {
  collectionName: string;
  url: string | null;
  copied: boolean;
  onCopy: () => void;
  onViewPage: () => void;
};

const AffiliateLinkReadyView = ({
  collectionName,
  url,
  copied,
  onCopy,
  onViewPage,
}: AffiliateLinkReadyViewProps) => {
  const { palette, spacing } = useTheme();

  return (
    <DSBox sx={{ mt: spacing(3) }}>
      <DSBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: spacing(1.25),
        }}
      >
        <DSBox
          sx={{ display: 'flex', alignItems: 'center', gap: spacing(0.75) }}
        >
          <DSBox
            sx={{
              width: 16,
              height: 16,
              borderRadius: '50%',
              backgroundColor: palette.success.main,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: '0 0 auto',
            }}
          >
            <CheckIcon
              sx={{ fontSize: 11, color: palette.background.default }}
            />
          </DSBox>
          <DSTypography variant="body2" sx={{ color: palette.success.light }}>
            live
          </DSTypography>
        </DSBox>
        <DSBox sx={{ textAlign: 'center' }}>
          <DSTypography
            variant="h5"
            sx={{
              color: palette.white[90],
              fontFamily: 'Gilroy-Bold',
              fontStyle: 'italic',
            }}
          >
            {collectionName}
          </DSTypography>
          <DSTypography
            variant="h5"
            sx={{ color: palette.white[90], fontFamily: 'Gilroy-Bold' }}
          >
            Klydoclock Bundle
          </DSTypography>
        </DSBox>
      </DSBox>

      <DSTypography
        variant="body2"
        sx={{
          color: palette.white[70],
          mt: spacing(0.75),
          textAlign: 'center',
          lineHeight: 1.55,
        }}
      >
        Offer the {collectionName} Klydoclock Bundle and earn $50 for every
        Klydoclock sold.
      </DSTypography>

      <DSBox
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing(1),
          backgroundColor: palette.white[5],
          borderRadius: '999px',
          p: `${spacing(0.75)} ${spacing(0.75)} ${spacing(0.75)} ${spacing(2.25)}`,
          mt: spacing(2.5),
          minHeight: 48,
        }}
      >
        {url ? (
          <DSTypography
            variant="body2"
            sx={{
              flex: 1,
              minWidth: 0,
              color: palette.white[70],
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {url}
          </DSTypography>
        ) : (
          <DSBox
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              gap: spacing(1.5),
            }}
          >
            <DSCircularProgress size={18} />
            <DSTypography variant="body2" sx={{ color: palette.white[56] }}>
              Loading link…
            </DSTypography>
          </DSBox>
        )}
        <DSPrimaryButton
          size="small"
          onClick={onCopy}
          disabled={!url}
          sx={{ minWidth: 84, flex: '0 0 auto' }}
        >
          {copied ? 'Copied' : 'Copy'}
        </DSPrimaryButton>
      </DSBox>

      <DSButton
        variant="text"
        color="secondary"
        onClick={onViewPage}
        disabled={!url}
        startIcon={<OpenInNewIcon sx={{ fontSize: 16 }} />}
        sx={{
          display: 'flex',
          mx: 'auto',
          mt: spacing(2),
          color: palette.white[70],
        }}
      >
        View Bundle Page
      </DSButton>
    </DSBox>
  );
};

export default AffiliateLinkReadyView;
